import {
    tourbillon,
    pingpong,
    memory,
    sudok,
    puzzle,
    reordon,
    melimots,
    quizz,
    codeExpress,
    Game
} from '../models/Games';

export const GAME_MAP: Record<string, Game> = {
    tourbillon,
    pingpong,
    memory,
    sudok,
    puzzle,
    reordon,
    melimots,
    quizz,
    'code-express': codeExpress
};
